import {Module} from 'vuex';
import {RootState} from '@/types';
import {namespace} from 'vuex-class';
import JobsAPI from '@/api/JobsAPI';
import {
  SET_JOB,
  SET_JOBS,
  SET_EXPIRE,
  SET_POINT,
  SET_CATEGORY,
  SET_JOBSTATUS,
  SET_ID_QUIZ,
} from '@/store/mutationTypes';

export const jobsModule = namespace('jobs');
export interface Jobs {
  [key: string]: any;
}

interface JobState {
  jobs: Jobs[];
  category: Jobs[];
  jobStatus: Jobs[];
  job: Jobs | null;
  point: Jobs | 0;
  expire: Jobs | 0;
  quizSetting: [];
}
export default <Module<JobState, RootState>>{
  namespaced: true,
  state: {
    jobs: [],
    category: [],
    jobStatus: [],
    job: null,
    point: 0,
    expire: 0,
    quizSetting: [],
  },
  mutations: {
    [SET_ID_QUIZ](state, data) {
      state.quizSetting = data;
    },
    [SET_JOBS](state, data) {
      state.jobs = data;
    },
    [SET_JOB](state, data) {
      state.job = data;
    },
    [SET_EXPIRE](state, data) {
      state.expire = data;
    },
    [SET_POINT](state, data) {
      state.point = data;
    },
    [SET_CATEGORY](state, data) {
      state.category = data;
    },
    [SET_JOBSTATUS](state, data) {
      state.jobStatus = data;
    },
  },
  actions: {
    async all({commit}, params = {}) {
      try {
        const {data} = await JobsAPI.all(params);
        commit(SET_JOBS, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async allStatusApply({commit}, params = {}) {
      try {
        const {data} = await JobsAPI.allStatusApply(params);
        commit(SET_JOBS, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async detailStatusApply({commit}, id) {
      try {
        const {data} = await JobsAPI.detailStatusApply(id);
        commit(SET_JOBS, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async category({commit}, params = {}) {
      try {
        const {data} = await JobsAPI.category(params);
        commit(SET_CATEGORY, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async detail({commit}, id) {
      try {
        const {data} = await JobsAPI.detail(id);
        commit(SET_JOBS, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async applyJobs(_, payload) {
      try {
        const data = await JobsAPI.applyJobs(payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getQuizIntroduction({commit}, params = {}) {
      try {
        const res = await JobsAPI.getQuizIntroduction(params);
        commit(SET_JOBS, res);
        return res;
      } catch (e) {
        return e.response;
      }
    },
    async getQuizIntroductionUser({commit}, params = {}) {
      try {
        const res = await JobsAPI.getQuizIntroductionUser(params);
        commit(SET_JOBS, res);
        return res;
      } catch (e) {
        return e.response;
      }
    },
    async getQuiz({commit}, params = {}) {
      try {
        const res = await JobsAPI.getQuiz(params);
        commit(SET_JOBS, res);
        return res;
      } catch (e) {
        return e.response;
      }
    },
    async sendQuiz(_, payload) {
      try {
        const data = await JobsAPI.sendQuiz({answare: payload});
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async changeStatusApplies(_, {id, payload}) {
      try {
        const data = await JobsAPI.changeStatusApplies(id, {
          confirmation_status: payload,
        });
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async newQuiz(_, payload) {
      try {
        const data = await JobsAPI.newQuiz(payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async updateQuiz(_, payload) {
      try {
        const data = await JobsAPI.updateQuiz(payload);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async checkProgress(_, params = {}) {
      try {
        const {data} = await JobsAPI.checkProgress(params);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
  },
};
